import * as React from 'react';

import { Link } from 'components/link/Link';
import Arrow from 'assets/svg/small-arrow.svg';

import s from './ArrowButton.scss';

interface IProps {
  to: string;
  children: React.ReactNode;
  direction?: 'back' | 'forward';
}

export const ArrowButton = ({ to, children, direction = 'back' }: IProps) => (
  <Link className={s('arrowButton', direction )} to={to}>
    <Arrow className={s.arrowButton__arrow} />
    <span className={s.arrowButton__text}>{children}</span>
  </Link>

);